import { useEffect } from 'react';
import utils from 'utils';
import CoverageStatus from 'app/hooks/plans/plans.enum';

interface IUsePendoParams {
  status: string;
  isDamageProtectionEnabled: boolean;
}

export default function useUpdatePendo({
  status,
  isDamageProtectionEnabled,
}: IUsePendoParams) {
  useEffect(() => {
    const { authenticatedData } =
      utils.getLocalStorageByKey('authenticatedData');
    if (!authenticatedData || !status) return;
    const { baseUserInfo } = authenticatedData;

    window.pendo.updateOptions({
      visitor: {
        id: baseUserInfo.userId,
      },
      account: {
        id: baseUserInfo.accountId,
        gfh_damageProtection: status === CoverageStatus.FULL,
        gfh_DPeligible: isDamageProtectionEnabled,
      },
    });
  }, [status, isDamageProtectionEnabled]);

  return null;
}
